import bgClass1 from 'src/assets/images/class1.jpg';
import bgClass2 from 'src/assets/images/class2.jpg';
import bgClass3 from 'src/assets/images/class3.jpg';
import bgClass4 from 'src/assets/images/class4.jpg';
import bgClass5 from 'src/assets/images/class5.jpg';

import Person1IconSVG from 'src/assets/svg/person-question/person1.svg';
import Person2IconSVG from 'src/assets/svg/person-question/person2.svg';
import Person3IconSVG from 'src/assets/svg/person-question/person3.svg';
import Person4IconSVG from 'src/assets/svg/person-question/person4.svg';
import Person5IconSVG from 'src/assets/svg/person-question/person5.svg';
import Person6IconSVG from 'src/assets/svg/person-question/person6.svg';
import Person7IconSVG from 'src/assets/svg/person-question/person7.svg';
import Person8IconSVG from 'src/assets/svg/person-question/person8.svg';
import Person9IconSVG from 'src/assets/svg/person-question/person9.svg';
import Person10IconSVG from 'src/assets/svg/person-question/person10.svg';

export const dataClassrooms = [
    {
        id: '1',
        nameClass: '1',
        imageClass: bgClass1,
    },
    {
        id: '2',
        nameClass: '2',
        imageClass: bgClass2,
    },
    {
        id: '3',
        nameClass: '3',
        imageClass: bgClass3,
    },
    {
        id: '4',
        nameClass: '4',
        imageClass: bgClass4,
    },
    {
        id: '5',
        nameClass: '5',
        imageClass: bgClass5,
    },
];

export const dataImagesPerson = [
    Person1IconSVG,
    Person2IconSVG,
    Person3IconSVG,
    Person4IconSVG,
    Person5IconSVG,
    Person6IconSVG,
    Person7IconSVG,
    Person8IconSVG,
    Person9IconSVG,
    Person10IconSVG,
];

export const dataChapters = [
    [
        { id: '1', name: 'Các số trong phạm vi 10' },
        { id: '2', name: 'Phép cộng, trừ trong phạm vi 10' },
        { id: '3', name: 'Các số trong phạm vi 100, độ dài' },
        { id: '4', name: 'Phép cộng, trừ trong phạm vi 100, thời gian' },
    ],
    [
        { id: '1', name: 'Phép cộng có nhớ trong phạm vi 100' },
        { id: '2', name: 'Phép trừ có nhớ trong phạm vi 100' },
        { id: '3', name: 'Phép nhân, chia cho 2,3,4,5' },
        { id: '4', name: 'Các số trong phạm vi 1000' },
    ],
    [
        { id: '1', name: 'Phép nhân, chia cho 6,7,8,9' },
        { id: '2', name: 'Các số trong phạm vi 10000' },
        { id: '3', name: 'Các số trong phạm vi 100000' },
    ],
    [
        { id: '1', name: 'Số tự nhiên, đơn vị đo khối lượng' },
        { id: '2', name: 'Bốn phép tính với các số tự nhiên' },
        { id: '3', name: 'Dấu hiệu chia hết cho 2,3,5,9' },
        { id: '4', name: 'Phân số - các phép tính với phân số' },
        { id: '5', name: 'Tỉ số - một số bài toán liên quan đến tỉ số' },
    ],
    [
        { id: '1', name: 'Ôn tập và bổ xung về phân số' },
        { id: '2', name: 'Số thập phân - các phép toán với số thập phân' },
        { id: '3', name: 'Hình học và các công thức tính diện tích, chu vi' },
        { id: '4', name: 'Số đo thời gian - toán chuyển động đều' },
    ],
];
